"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _awsAmplify = require("aws-amplify");

/*
 * Jira Ticket:
 * Created Date: Thu, 9th Jan 2020, 12:13:02 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */
var currentSession = function currentSession() {
  return _awsAmplify.Auth.currentSession().then(function (session) {
    if (!session) {
      return Promise.reject(new Error('You need to sign in to access that page.'));
    } // Update the permissions


    localStorage.setItem('permissions', session.idToken.payload.permissions);
    return session;
  }).catch(function (error) {
    console.error('Session Error:', error);
    return Promise.reject(new Error('Session Expired'));
  });
};

var _default = currentSession;
exports.default = _default;